<template>
  <iColumn
    gap="none"
    width="fill"
    :style-overrides="{paddingTop: 'extraSmall'}"
  >
    <template
      v-for="(shades, color) in myPrimitivePaletteList"
      :key="color"
    >
      <iRow
        v-if="color !== 'transparent'"
        wrap="nowrap"
        vertical-align="middle"
        align="between"
        :style-overrides="{
          paddingLeft: 'standard',
          paddingRight: 'standard',
        }"
        position="relative"
        :class="{
          'color-row':true,
          selected: isSelected(shades, color)
        }"
        gap="extraSmall"
      >
        <template v-for="(colorCode, shade) in shades">
          <div
            v-if="colorCode !== 'transparent'"
            :key="shade"
            :class="{'active': modelValue === `${color}.${shade}`, 'active-group': isSelected(shades, color)}"
            :style="`background: ${colorCode}`"
            class="color-block"
            @click="selectValue(`${color}.${shade}`)"
          />
        </template>
      </iRow>
    </template>
    <iColumn
      v-if="allowTransparent"
      :style-overrides="{paddingTop: 'extraSmall', paddingBottom: 'extraSmall'}"
      align="center"
      width="fill"
    >
      <iButton
        size="extraSmall"
        variant="tertiary"
        @click="selectTransparent"
      >
        Set as transparent
      </iButton>
    </iColumn>
  </iColumn>
</template>

<script>
import { markRaw } from "vue";
import { useStyleStore } from "@bloglovin/vue-component-library";

export default {
  name: "PrimitiveColorPicker",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "",
    },
    context: {
      type: String,
      required: false,
      default: "font",
    },
    themeIdContext: {
      type: [String, Number],
      required: false,
      default: "default",
    },
    allowTransparent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    myPrimitivePaletteList() {
      return markRaw(useStyleStore().themePalettes[this.themeIdContext].colors);
    },
  },
  methods: {
    isSelected(shades, color) {
      for (const shade in shades) {
        if (this.modelValue === `${color}.${shade}`) {
          return true;
        }
      }
      return false;
    },
    selectTransparent() {
      this.$emit("update:modelValue", "transparent.100");
    },
    selectValue(color) {
      this.$emit("update:modelValue", color);
    },
  },
  styleGuide: () => ({
    hoverBackgroundColor: { "color.background": "light" },
    selectedBackgroundColor: { "color.border": "striking" },
  }),
};
</script>

<style lang="scss" scoped>
.color-row.row {
  padding-top: 3px;
  padding-bottom: 3px;

  &:hover {
    cursor: pointer;
    background-color: v-bind("$getStyles.hoverBackgroundColor");
  }

  &.selected {
    background-color: v-bind("$getStyles.selectedBackgroundColor");
  }
}

.color-block {
  height: 24px;
  width: 24px;
  cursor: pointer;
  border-radius: 4px;
  border: 1px solid transparent;
  outline: 2px solid transparent;

  &:not(.active-group) {
    border: 1px solid grey;

    &:hover {
      border: 1px solid grey;
      outline: 2px solid black;
    }
  }

  &.active-group {
    &:hover {
      border: 1px solid black;
      outline: 2px solid grey;
    }

    &.active {
      border: 1px solid grey;
      outline: 2px solid black;
    }
  }
}
</style>
